/**
 * RefreshIcon/index.js
 * desc: icon used to refresh content
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const RefreshIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="refresh icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.refresh.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.64 2.35A7.958 7.958 0 007.99 0C3.57 0 0 3.58 0 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08a5.99 5.99 0 01-5.65 4c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L8.99 7h7V0l-2.35 2.35z"/></svg>
    </IconButton>
);


export default RefreshIcon;
